// 工业级智能体产品分类与产品矩阵数据
import product_material_rd from "@/../static/img/product/product_material_rd.png";
import product_manufacture_UniCoal from "@/../static/img/product/product_manufacture_UniCoal.png";
import product_manufacture_UniStlCCasting from "@/../static/img/product/product_manufacture_UniStlCCasting.png";
import product_manufacture_UniStlDetection from "@/../static/img/product/product_manufacture_UniStlDetection.png";
import product_manufacture_UniSteel from "@/../static/img/product/product_manufacture_UniSteel.svg";
import product_manufacture_UniSecurity from "@/../static/img/product/product_manufacture_UniSecurity.png";
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";

export const MANUFACTURE_CATEGORIES = [
  {
    key: "research",
    title: "科学研究",
    bgType: 2,
    products: [
      {
        title: "AI新材料研发智能平台",
        info:
          "面向结构材料（金属合金、无机非金属、高分子等）和功能材料（磁性材料、催化材料、发光材料等）研发领域，以AI为核心引擎，致力于重塑研发流程，通过构建可溯源的领域知识库和材料数据库，协同多尺度仿真与自动化实验验证，深度解析「成分-工艺-组织-性能」间的复杂关系，实现材料性能的精准正向预测与基于目标导向的逆向成分工艺设计，建立覆盖「数据挖掘-模型驱动-工艺优化-实验验证」全流程的智能化闭环研发体系，助力新材料研发迈入数据智能驱动新范式。",
        image: product_material_rd,
        alt: "AI新材料研发智能平台",
        advantages: [
          "缩短新材料研发周期，降低研发成本",
          "沉淀材料领域专业知识，专家经验数字化",
          "推动新材料研发由'经验驱动'向'数据驱动'转变"
        ]
      }
    ]
  },
  {
    key: "blending",
    title: "配料优化",
    bgType: 1,
    products: [
      {
        title: "焦化行业智能配煤系统",
        info:
          "基于认知智能的鲁棒学习算法、小样本学习、数据＋知识融合进行配煤优化和焦炭质量精准预测，以成本和效益优先为指导进行资源配置，显著降低配煤成本；通过智能配煤来保证生产焦炭的质量，合理利用煤炭资源，节约高价值的炼焦煤资源，扩大炼焦煤资源，实现焦炭生产的保质增效。",
        image: product_manufacture_UniCoal,
        alt: "Uni-CCoking",
        advantages: [
          "稳定焦炭质量，提供采购建议",
          "优化配煤结构，严控生产成本",
          "实验数据参考，提高工作效率",
          "数据安全保障，系统易于使用"
        ]
      }
    ]
  },
  {
    key: "quality",
    title: "质量闭环管控",
    bgType: 2,
    products: [
      {
        title: "连铸质量判定系统",
        info:
          "基于连铸推理引擎及质量判定引擎，通过对生产切割、炉次、铸流、冶炼等生产数据的建模及实时分析，实现连铸质量预测、在线质量判定、缺陷根因分析、连铸生产工艺优化、切割优化、生产过程跟踪等功能，达到稳定连铸坯质量、优化成本效益及质量管控模式转换与精益化管理的目标。",
        image: product_manufacture_UniStlCCasting,
        alt: "Uni-StlCCasting",
        advantages: [
          "提升板坯质量预判和评级精准度",
          "提高板坯质量管控水平",
          "提高板坯收得率"
        ]
      },
      {
        title: "表面缺陷检测系统",
        info:
          "表面缺陷检测系统采用高帧率、高分辨率工业相机，对产品表面缺陷进行实时在线检测，基于感知模型和认知模型，从多个维度对缺陷进行分析、识别和判定，从而解决现有感知模型无法理解缺陷识别的逻辑关系所导致的性能瓶颈，大大提高现有缺陷的分类准确率，以便精确追溯缺陷产生原因，并生成相应解決方案，保证产品质量。",
        image: product_manufacture_UniStlDetection,
        alt: "Uni-StlDetection",
        advantages: [
          "提升缺陷检出和分类精准度",
          "提高产品质量管控水平",
          "产品质量带动生产效益"
        ]
      }
    ]
  },
  {
    key: "safety",
    title: "智慧安全",
    bgType: 1,
    products: [
      {
        title: "飞钢智能安监系统",
        info:
          "基于工业摄像机和AI视觉技术，对轧线堆钢、飞钢多发位置进行7×24小时实时监控，精准识别轧件过度弯曲、堆钢、飞钢等异常，及时报警并可联锁PLC控制设备（卡断剪、碎断、快停），实现从识别到控制的快速闭环，防止事故扩大，确保工作人员的生命安全。系统识别准确率≥99%，响应时间≤600ms，有效提升生产安全与智能化水平。",
        image: product_manufacture_UniSteel,
        alt: "Uni-StlRolling",
        advantages: ["实时监控", "精准识别", "毫秒级响应", "溯源记录"]
      },
      {
        title: "厂区安全智能巡检系统",
        info:
          "厂区安全智能巡检系统通过AI算法，实现对厂区生产现场的实时合规监控。系统可精准识别抽烟、违规通话、玩手机、未戴安全帽及明火等安全隐患，并即时预警。系统部署方案高度灵活，可根据现场硬件算力及具体巡检需求，量身定制单项或多项并发任务。厂区安全智能巡检系统有效降低了人工巡检压力，提升了厂区风险闭环管理的自动化水平。",
        image: product_manufacture_UniSecurity,
        alt: "Uni-FacSafety",
        advantages: [
          "减少安全隐患规避损失：",
          "提升安全巡检标准化和效率：",
          "实现安全问题全流程管理："
        ]
      }
    ]
  }
];

export const superiorityIcon = product_society_superiority;

export function getCategoryByKey(key) {
  return MANUFACTURE_CATEGORIES.find(item => item.key === key);
}



// WEBPACK FOOTER //
// ./src/view/product/manufacture/categoryData.js